interface IAccountInvitationConfirmationProps {
    email: string;
    registrationCode: string;
}

class AccountInvitationConfirmation extends React.Component<IAccountInvitationConfirmationProps, any> {
    public render(): JSX.Element {
        return (
            <div className="content">
                <h4 className="thin-font"> {cacheStore.GetString("SendInvitationSuccessLabel")} :</h4>
                <p className="bold">{this.props.email}</p>
                {this.props.registrationCode && (
                    <>
                        <p> {cacheStore.GetString("SendInvitationCodeLabel")} : </p>
                        <h2>{this.props.registrationCode}</h2>
                        <div style={{ margin: "15px 0 10px" }}>
                            <a onClick={this.printCode.bind(this)}>{cacheStore.GetString("PrintLabel")}</a>
                        </div>
                    </>
                )}
            </div>
        );
    }

    private printCode(): void {
        var html = "<html><head><title>" + cacheStore.GetString("RegistrationCodeLabel") + " </title></head>";
        html += "<body><div><h3>" + cacheStore.GetString("RegistrationCodeLabel") + " : " + this.props.registrationCode + "</h3></div></body></html>";
        var w = window.open("", "PRINT", "height=200,width=400");
        w.document.write(html);
        w.document.close();
        w.focus();
        w.print();
        w.close();
    }
}

export { AccountInvitationConfirmation };
